import React from 'react';

import { Portal } from 'Wpds/components/portal/Portal';

import MeetingItemDetailPanel from './MeetingItemDetailPanel';

type Props = {
  onClose?: Function;
};

const MeetingItemDetailModal = ({ onClose }: Props) => {
  return (
    <Portal idPrefix="meeting-item-details">
      <MeetingItemDetailPanel handleClosePanel={onClose} />
    </Portal>
  );
};

export default MeetingItemDetailModal;
